<template>
    <b-card no-body border-variant="light">
        <div class="card-header">
            <h4>
                <span v-for="(title, index) in componentHeader">
                    <feather-icon
                        v-if="index > 0"
                        icon="ChevronRightIcon"
                    />
                    {{ title }}
                </span>
            </h4>
        </div>
        <div class="pl-2 pr-2">
            <Transition name="zoom-fade">
                <b-alert
                    variant="success"
                    v-if="showDoesNotHaveConcernSubstances"
                    :show="true"
                >
                    <div class="alert-body">
                        {{ $t('Component(Text):component-does-not-have-concern-substances') }}
                    </div>
                </b-alert>
                <b-alert
                    variant="warning"
                    v-if="showUnclearMessage"
                    :show="true"
                >
                    <div class="alert-body">
                        {{ $t('Component(Text):it-is-unclear-if-component-has-concern-substances') }}
                    </div>
                </b-alert>
                <b-alert
                    variant="warning"
                    v-if="showNotAllDefinedMessage"
                    :show="true"
                >
                    <div class="alert-body">
                        {{ $t('Page(ReceivedRequest):Component(ConcernElements):message-not-all-declared') }}
                    </div>
                </b-alert>
            </Transition>
        </div>
        <SubstanceList
            class="pl-50 pr-50"
            :substances="substances"
            :substance-lists="substanceLists"
        />
    </b-card>
</template>

<script>
import {BCard, BRow, BCol, BAlert} from 'bootstrap-vue'
import Substance from "@/views/product/components/product-card/composition/Substance.vue";
import SubstanceList from "@/views/product/components/product-card/composition/SubstanceList.vue";
import {SubstanceState} from "@/libs/product";

export default {
    components: {
        BCard, BRow, BCol, BAlert, Substance, SubstanceList
    },
    props: {
        container: {
            required: true,
            type: Object
        },
        substanceLists: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    computed: {
        showUnclearMessage() {
            return [
                SubstanceState.ALL_UNDEFINED,
                SubstanceState.SOME_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES
            ].includes(this.container.state);
        },
        showNotAllDefinedMessage() {
            return [
                SubstanceState.SOME_DEFINED_INCLUDES_SUBSTANCES
            ].includes(this.container.state);
        },
        showDoesNotHaveConcernSubstances() {
            return [
                SubstanceState.ALL_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES
            ].includes(this.container.state);
        },
        component() {
            return this.container.component;
        },
        hasConcernElements() {
            return this.container.concernElements.length > 0;
        },
        substances() {
            return this.container.substances;
        },
        componentHeader() {
            return this.container.parents.map(c => c.title);
        }
    }
}
</script>
